export function extractErrorMessage(errorOrResponse) {
    try {
        if (!errorOrResponse) return null;

        const status =
            errorOrResponse.response?.status || errorOrResponse.status || null;

        const data =
            errorOrResponse.response?.data ||
            errorOrResponse.data ||
            errorOrResponse.error ||
            null;

        // ✅ Handle HTML error pages (500 etc.)
        if (typeof data === "string" && data.trim().startsWith("<")) {
            if (status === 500) return "Server error. Please try again later.";
            return null;
        }

        if (!data) {
            if (status === 500) return "Server error. Please try again later.";
            return null;
        }

        // ✅ Case 1: { errors: { error: ["msg"] } }
        if (data.errors?.error && Array.isArray(data.errors.error)) {
            let rawMsg = data.errors.error[0];
            if (typeof rawMsg === "string") {
                rawMsg = rawMsg.replace(/^{['"]?|['"]?}$/g, "");
            }
            return rawMsg;
        }

        // ✅ Case 2: { errors: { fieldName: ["msg"] } }
        if (data.errors && typeof data.errors === "object") {
            const firstKey = Object.keys(data.errors)[0];
            const value = data.errors[firstKey];
            if (Array.isArray(value)) return value[0];
            if (typeof value === "string") return value;
        }

        // ✅ Case 3: DRF style { detail: "..." }
        if (data.detail) return data.detail;

        // ✅ Case 4: flat { field: ["msg"] }
        const firstKey = Object.keys(data)[0];
        const value = data[firstKey];
        if (Array.isArray(value)) return value[0];
        if (typeof value === "string") return value;

        return null;
    } catch {
        return null;
    }
}
